import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import DataGrid, { Column, LoadPanel, Scrolling, Selection } from "devextreme-react/data-grid";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "280px"
    }
  }
};

class EditRolesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedRoles: this.props.personRoles || [],
      focusedRole: -1,
      focusedRowIndex: -1
    };

    this.selectRoles = this.selectRoles.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
    this.onFormChange = this.props.onFormChange.bind(this);
  }

  selectRoles({ selectedRowsData }) {
    this.setState({ selectedRoles: selectedRowsData });
    this.onFormChange(this.state.selectedRoles);
  }

  onRowClick(e) {
    const focusedRole = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedRole, focusedRowIndex });
  }

  render() {
    const {
      selectedRoles,
      focusedRowIndex,
      focusedRole
    } = this.state;
    const {
      roles,
      classes,
      rolesList = [],
      personRoles
    } = this.props;
    const { root, personContainer, controls } = classes;

    return (
      <div className={root}>
            <DataGrid
              elementAttr={{
                id: "gridContainer"
              }}
              ref={this.dataGridRef}
              wordWrapEnabled={true}
              dataSource={rolesList}
              onSelectionChanged={this.selectRoles}
              selectedRowKeys={selectedRoles}
              focusedRowEnabled
              errorRowEnabled={false}
              onRowClick={this.onRowClick}
              focusedRowIndex={focusedRowIndex}
              showBorders
            >
              <Selection
                mode="multiple"
                showCheckBoxesMode="onClick"
                showBorders={true}
                width={120}
              />
              <Column
                dataField="id"
                caption="ID"
                dataType="number"
                align="left"
                width={60}
              />
              <Column
                dataField="name"
                caption="Наименование"
                dataType="string"
              />
              <Scrolling mode="virtual" />
              <LoadPanel enabled/>
            </DataGrid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  rolesList: state.dictRolesView.list,
  personRoles: state.persons.roles
});

const mapDispatchToProps = dispatch => ({
  //loadList: () => dispatch(loadList())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EditRolesForm));
